/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    string,
} from 'prop-types';

const FilterIcon = ({
    fillColor,
    version,
}) => {
    if (version === 'v2') {
        return (
            <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5127 0.100586C7.12166 0.100586 8.4248 1.40498 8.4248 3.0127C8.4248 4.62041 7.12166 5.9248 5.5127 5.9248C3.90373 5.9248 2.60059 4.62041 2.60059 3.0127C2.60059 1.40498 3.90373 0.100586 5.5127 0.100586ZM5.5127 1.5498C4.70491 1.5498 4.0498 2.20541 4.0498 3.0127C4.0498 3.81998 4.70491 4.47559 5.5127 4.47559C6.32048 4.47559 6.97559 3.81998 6.97559 3.0127C6.97559 2.20541 6.32048 1.5498 5.5127 1.5498Z" fill={fillColor} stroke={fillColor} strokeWidth="0.2" />
                <path d="M3.3252 2.28809C3.7256 2.28809 4.0498 2.61229 4.0498 3.0127C4.0498 3.4131 3.7256 3.7373 3.3252 3.7373H0.825195C0.424792 3.7373 0.100586 3.4131 0.100586 3.0127C0.100586 2.61229 0.424792 2.28809 0.825195 2.28809H3.3252Z" fill={fillColor} stroke={fillColor} strokeWidth="0.2" />
                <path d="M17.0752 2.28809C17.4755 2.28809 17.7998 2.61229 17.7998 3.0127C17.7998 3.4131 17.4755 3.7373 17.0752 3.7373H7.7002C7.29979 3.7373 6.97559 3.4131 6.97559 3.0127C6.97559 2.61229 7.29979 2.28809 7.7002 2.28809H17.0752Z" fill={fillColor} stroke={fillColor} strokeWidth="0.2" />
                <path d="M12.3877 6.97559C13.9967 6.97559 15.2998 8.27998 15.2998 9.8877C15.2998 11.4954 13.9967 12.7998 12.3877 12.7998C10.7787 12.7998 9.47559 11.4954 9.47559 9.8877C9.47559 8.27998 10.7787 6.97559 12.3877 6.97559ZM12.3877 8.4248C11.5799 8.4248 10.9248 9.0804 10.9248 9.8877C10.9248 10.695 11.5799 11.3506 12.3877 11.3506C13.1954 11.3506 13.8506 10.695 13.8506 9.8877C13.8506 9.0804 13.1954 8.4248 12.3877 8.4248Z" fill={fillColor} stroke={fillColor} strokeWidth="0.2" />
                <path d="M17.0752 9.16309C17.4755 9.16309 17.7998 9.48734 17.7998 9.8877C17.7998 10.288 17.4755 10.6123 17.0752 10.6123H14.5752C14.1748 10.6123 13.8506 10.288 13.8506 9.8877C13.8506 9.48734 14.1748 9.16309 14.5752 9.16309H17.0752Z" fill={fillColor} stroke={fillColor} strokeWidth="0.2" />
                <path d="M10.2002 9.16309C10.6006 9.16309 10.9248 9.48735 10.9248 9.8877C10.9248 10.288 10.6006 10.6123 10.2002 10.6123H0.825195C0.424787 10.6123 0.100586 10.288 0.100586 9.8877C0.100586 9.48735 0.424787 9.16309 0.825195 9.16309H10.2002Z" fill={fillColor} stroke={fillColor} strokeWidth="0.2" />
            </svg>
        );
    }
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill={fillColor} d="M9,5.5A1.5,1.5,0,1,1,7.5,4,1.5,1.5,0,0,1,9,5.5ZM7.5,8A2.5,2.5,0,0,0,9.95,6H18a.5.5,0,0,0,0-1H9.95a2.5,2.5,0,0,0-4.9,0H2A.5.5,0,0,0,2,6H5.05A2.5,2.5,0,0,0,7.5,8ZM11,14.5A1.5,1.5,0,1,0,12.5,13,1.5,1.5,0,0,0,11,14.5ZM12.5,12a2.5,2.5,0,0,1,2.45,2H18a.5.5,0,0,1,0,1H14.95a2.5,2.5,0,0,1-4.9,0H2a.5.5,0,0,1,0-1h8.05A2.5,2.5,0,0,1,12.5,12Z" />
        </svg>
    );
};

FilterIcon.propTypes = {
    fillColor: string,
    version: string,
};

FilterIcon.defaultProps = {
    fillColor: '#2F2F2F',
    version: 'v1',
};

export default FilterIcon;
